import React from 'react';

import Page from 'marketing-website/components/modules/Page';
import assets from 'marketing-website/configs/pages/marvel-vs-zeplin/assets';
import metaData from 'marketing-website/data/metadata.js';
import ImageBlock from 'marketing-website/components/modules/ImageBlock';
import Header from 'marketing-website/components/modules/CompetitorAlternatives/Header.js';
import Logos from 'marketing-website/components/modules/CompetitorAlternatives/Logos.js';
import RequestDemo from 'marketing-website/components/modules/CompetitorAlternatives/RequestDemo.js';

const facebookMeta = [
  {
    name: 'og:title',
    content: 'Searching for a Zeplin alternative?',
  },
  {
    name: 'og:site_name',
    content: 'Marvel Vs Zeplin',
  },
  {
    name: 'og:type',
    content: 'website',
  },
  {
    name: 'og:url',
    content: 'https://marvelapp.com/marvel-vs-zeplin',
  },
  {
    name: 'og:description',
    content: `Read about Zeplin vs Marvel - compare the benefits of using Marvel for your design to developer code handoff versus Zeplin.`,
  },
  {
    name: 'og:image',
    content: `https://marvelapp.com${assets.header.src}`,
  },
  {
    name: 'og:site_name',
    content: 'Marvel Vs Zeplin',
  },
];

const twitterMeta = [
  {
    name: 'twitter:site',
    content: 'https://marvelapp.com/marvel-vs-zeplin',
  },
  {
    name: 'twitter:creator',
    content: 'Marvel Vs Zeplin',
  },
  {
    name: 'twitter:title',
    content: 'Searching for a Zeplin alternative?',
  },
  {
    name: 'twitter:image',
    content: `https://marvelapp.com${assets.header.src}`,
  },
];

const meta = {
  title: metaData['marvel-vs-zeplin'].title,
  meta: [
    {
      name: 'description',
      content: metaData['marvel-vs-zeplin'].description,
    },
    ...twitterMeta,
    ...facebookMeta,
  ],
  header: { isLight: false },
  footer: true,
};

export default function MarvelVsZeplin() {
  return (
    <Page {...meta}>
      <Header
        heading="Designer to developer code handoff"
        subHeading="Collaboration from designer to developer is essential for a smooth implementation of designs. An accurate code handoff tool will save hours of unnecessary work."
        headerImage={assets.header}
        mainColor="green"
      />
      <Logos />
      <ImageBlock
        paragraphSize="m"
        title="Turn designs into code, specs and assets"
        copy="Automatically turn designs into accurate developer specifications with code, measurements and specs that you can quickly copy into your code editor, reducing errors when moving into development. Alongside that, Handoff generates all of the assets within the design file into a handy ZIP file."
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.designsIntoCode}
      />
      <ImageBlock
        paragraphSize="m"
        title="Public developer share links for easy access"
        copy="Give instant access to your developers with public share links direct to the specs and assets needed to they can start building straight away. Place links in JIRA issues, spec documents, Slack and emails so the team can access what they need, when they need."
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.publicShare}
        isRightAligned
      />
      <ImageBlock
        paragraphSize="m"
        title="Keep Handoff in sync with your design system"
        copy="With Marvel Handoff, you’ll get access to any symbol and style names that have been set in Sketch, allowing developers to easily access any layer and see exactly what part of the design relates to the design system."
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.symbolSync}
      />
      <ImageBlock
        paragraphSize="m"
        title="Integrated prototyping"
        copy="Handoff is displayed next to its interactive prototype so your developers can see exactly how the designs interact, side by side with how to to build them."
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.handoffPrototyping}
        isRightAligned
      />
      <ImageBlock
        paragraphSize="m"
        title="Validate before development"
        copy="Get actionable insights prior to development with built-in usability testing tools. Gather video, voice and analytics and discover how to make your designs perform better."
        headingMaxWidth={430}
        paragraphMaxWidth={430}
        imageAsset={assets.userTesting}
      />
      <RequestDemo backgroundColor="green" image={assets.header} />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/marvel-vs-zeplin/index.js